export default __webpack_public_path__ + "static/zap-af022a74e59b8bc7bddf4dc6bee8c653.png";